import { FC, useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import { PageWrapper } from 'components/ui';
import { DicomList, LinkPassword } from '../components';

const DicomViewer: FC = () => {
  const [isVisible, setVisible] = useState(false);
  const [refreshSignal, setRefreshSignal] = useState(0);

  return (
    <PageWrapper
      title="DICOM Viewer"
      color="white"
      extra={[
        <Button
          type="primary"
          style={{ width: 250 }}
          onClick={() => setVisible(true)}
          key="generate_link_password"
        >
          <PlusOutlined />
          Generate Link & Password
        </Button>
      ]}
    >
      <DicomList refreshSignal={refreshSignal} />
      {isVisible && (
        <LinkPassword
          onClose={() => setVisible(false)}
          onSaved={() => setRefreshSignal(k => k + 1)}
        />
      )}
    </PageWrapper>
  );
};

export default DicomViewer;
